import { render, staticRenderFns } from "./SparePartCategoryDialog.vue?vue&type=template&id=1c408f5e"
import script from "./SparePartCategoryDialog.vue?vue&type=script&lang=ts"
export * from "./SparePartCategoryDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports